import { useLocalStorage } from '@vueuse/core'
import { defineStore } from 'pinia'

export const useDarkModeStore = defineStore('darkMode', () => {
  const darkMode = useLocalStorage('darkMode', false)
  function toggleDarkMode() {
    darkMode.value = !darkMode.value
  }
  function setDarkMode() {
    darkMode.value = true
  }
  function setLightMode() {
    darkMode.value = false
  }
  return { darkMode, toggleDarkMode, setLightMode, setDarkMode }
})
